var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/CopyRight/index.tsx",
  _this = this;
import React from 'react';
import useStyles from './useStyles';
var CopyRight = function CopyRight() {
  var _useStyles = useStyles(),
    copyRight = _useStyles.copyRight;
  var year = new Date().getFullYear();
  return /*#__PURE__*/React.createElement("span", {
    className: copyRight,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 5
    }
  }, "Copyright \xA9 1999-".concat(year, " SurveyMonkey"));
};
export default CopyRight;
//# sourceMappingURL=index.js.map